import { SET_LINE_OF_BUSINESS, SET_SELECTED_TINS, SET_TIME_PERIOD, SET_SERVICE_TYPE, SET_CLAIM_TYPE, SET_VENDOR_NAME } from "@src/middleware/actions/customHooksActions/actionTypes";


const initialState = {
    selectedTINs: [],
    lineOfBusiness: 'All',
    timePeriod: null,
    claimType: 'All',
    serviceType: 'All',
    Vendor: 'All'
};

const filterReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SELECTED_TINS:
            return { ...state, selectedTINs: action.payload };
        case SET_LINE_OF_BUSINESS:
            return { ...state, lineOfBusiness: action.payload };
        case SET_TIME_PERIOD:
            return { ...state, timePeriod: action.payload };
        case SET_CLAIM_TYPE:
            return { ...state, claimType: action.payload };
        case SET_SERVICE_TYPE:
            return { ...state, serviceType: action.payload };
        case SET_VENDOR_NAME:
            return { ...state, Vendor: action.payload };
        default:
            return state;
    }
};

export default filterReducer
